import { useState, useEffect } from 'react'
import { useI18n } from 'builder/hooks/useI18n'
import * as Styles from './styles'

type Props = {
  isSyncing: boolean
}

export const SaveIndicator = ({ isSyncing }: Props) => {
  const { i18n } = useI18n()
  const [isVisible, setIsVisible] = useState(false)

  useEffect(() => {
    if (isSyncing) {
      setIsVisible(true)
      return
    }

    const timeout = setTimeout(() => {
      setIsVisible(false)
    }, 500)

    return () => {
      clearTimeout(timeout)
    }
  }, [isSyncing])

  return (
    <Styles.Container $isSyncing={isVisible}>
      {isSyncing ? <Styles.Spinner /> : <Styles.SavedIcon />}
      <Styles.Text>{i18n.t(`builder.resume_editor.${isSyncing ? 'saving' : 'saved'}`)}</Styles.Text>
    </Styles.Container>
  )
}
